import {useMemo} from 'react';
import type {Part} from 'schemaDefinition/types';
import type {CodeListId} from 'services/codelists/types';
import {
  getPartCodelistId,
  getSchemaListCodelistIds,
} from 'schemaDefinition/functions';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';

export const usePartCodelistIds = (
  part: Part,
): (CodeListId | LinkedRoleCodeListId)[] | undefined => {
  return useMemo(() => {
    if (part.type === 'schema') {
      return getSchemaListCodelistIds([part]);
    }

    return getPartCodelistId(part);
  }, [part]);
};
